import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { verifyEmail } from '../api'; // Updated to use verifyEmail

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 useEffect(() => {
  const token = searchParams.get('token');
  const id = searchParams.get('id'); // ✅ GET id from URL

  if (!token || !id) {
    setError('Invalid verification link');
    setLoading(false);
    return;
  }

  const verifyEmailProcess = async () => {
    try {
      setLoading(true);
      await verifyEmail(token, id); // ✅ Pass both token and id
      setLoading(false);
      navigate('/', { replace: true }); // Redirect to login
    } catch (err) {
      setError(err.message || 'Verification failed');
      setLoading(false);
    }
  };

  verifyEmailProcess();
}, [searchParams, navigate]);


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return null; // Redirect handled, no need to render
};

export default VerifyEmail;